import { render } from "./AzureOpenAIAPIBotSettings.vue?vue&type=template&id=5374fd33"
import script from "./AzureOpenAIAPIBotSettings.vue?vue&type=script&lang=js"
export * from "./AzureOpenAIAPIBotSettings.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__